export default "__VITE_ASSET__DGZ7RA2o__"